import useExperiments from "@Hooks/selector/useExperiments";
import RouteType from "@Route/types/Route.type";
import ParamsType from "@SearchResults/types/params/Params.type";

export default function useFlixbusViaTravelierConnectExperiment(params: ParamsType) {
    const {flixbusViaTC} = useExperiments()
    const {
        departureStation: {
            countryId: departureCountryId,
        },
        destinationStation: {
            countryId: destinationCountryId,
        },
    } = params

    // Croatia, BIH, Serbia, Montenegro
    const excludedCountryIds = [1, 2, 5, 9]

    const prepareRoutesForExperiment = (routes: RouteType[]) => {
        let filteredRoutes = routes
        const hasTConnectRoutes = routes.some((route) => route.companyId === '4955')
        const hasFlixbusRoutes = routes.some((route) => route.companyId === '488')
        const isExcludedCountry = excludedCountryIds.includes(departureCountryId) || excludedCountryIds.includes(destinationCountryId)
        if (hasTConnectRoutes && !isExcludedCountry) {
            if (flixbusViaTC) {
                filteredRoutes = routes.map((route) => {
                    if (route.companyId === '488') {
                        return null
                    }

                    return route
                })
            } else {
                filteredRoutes = routes.map((route) => {
                    if (route.companyId === '4955') {
                        return null
                    }

                    return route
                })
            }
        }

        if (hasFlixbusRoutes && isExcludedCountry) {
            filteredRoutes = routes.map((route) => {
                if (route.companyId === '4955') {
                    return null
                }

                return route
            })
        }

        return filteredRoutes.filter((route) => !!route)
    }

    return {
        prepareRoutesForExperiment,
        flixbusViaTC,
    }
}